<div class="container-fluid mt-3 mb-5">
  <div class="container">
    <div class="row">
      <div class="col">
        <c11n-internal-callout [variant]="isSmallScreen?'vertical': 'horizontal'" [headingLevel]="2">
          <p class="c11n-text-md-bold">{{ content?.crewOnlyMessage || 'This page is for crew only. Clients cannot view this page.' }}</p>
        </c11n-internal-callout>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col m-auto">
        <c11n-spinner *ngIf="loading" class="spinner-on-send-screen" [size]="'medium'" [colorMode]="'on-light'"
                      [spinnerStatus]="'loading...'">
        </c11n-spinner>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-md-8 col-lg-8 m-auto">
        <div class="process-flow-pattern__content-header">
            <span
              class="default__family-font d-none d-sm-block c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"
              tabindex="-1"
              #title
            >{{ content?.sendDuplicateConfirmationLabel || 'Send duplicate confirmation' }}</span>
          <span class="d-block d-sm-none c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"></span>

          <c11n-button
            [size]="'small'"
            [labelText]="'Quit'"
            [variant]="'ghost'"
            [iconPosition]="'trailing'"
            (clickEvent)="onCancel()"
            iconName="remove"
            class="process-flow-pattern__quit-btn"
          >
          </c11n-button>
        </div>
        <section class="c11n-space-stack-6x">
          <div class="mb-1 process-flow-pattern__content-heading d-block d-sm-none">
            <span
              class="default__family-font c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"
              tabindex="-1"
              #title
            >{{ content?.sendDuplicateConfirmationLabel || 'Send duplicate confirmation' }}</span>
          </div>
          <div class="c11n-text-sm-bold c11n-space-stack-2x">
            {{ getStepText(1) }}
          </div>
          <c11n-step-indicator
            [currentStep]="(currentStepIndicatorIndex$ | async) || 1"
            [stepLabels]="[
              content?.stepLabels?.selectRecipient || 'Select recipient',
              content?.stepLabels?.reviewSubmit || 'Review & submit',
              content?.stepLabels?.confirmation || 'Confirmation'
            ]"
            [direction]="isSmallScreen ? 'vertical' : 'horizontal'">
          </c11n-step-indicator>
        </section>
        <!-- Statement Details Section -->
        <section role="region" aria-label="Statement Details">
          <header class="statement-details-left send-duplicate__headers">
            <h2 class="main-title">{{ content?.headers?.selectRecipient || 'Select recipient' }}</h2>
          </header>

          <!-- Statement Details -->
          <ng-container *ngIf="statementDetails$ | async as statementDetails">
            <dl class="details-grid">
              <div class="detail-row">
                <dt class="label c11n-text-md-bold"><strong>{{ content?.tableLabels?.confirmationDate || 'Confirmation date' }}</strong></dt>
                <dd class="value c11n-text-md">{{ statementDetails.confirmationDate }}</dd>
              </div>
              <div class="detail-row">
                <dt class="label c11n-text-md-bold"><strong>{{ content?.tableLabels?.account || 'Account' }}</strong></dt>
                <dd class="value c11n-text-md">{{ statementDetails.description }}</dd>
              </div>
            </dl>
            <dl>
              <dd class="value" *ngIf="recipients.length !== 0">
                <app-recipient-radio-list
                  [recipients]="recipients"
                  [(selectedRecipientKey)]="selectedRecipientKey"
                  (selectionChanged)="onRecipientChange()">
                </app-recipient-radio-list>
              </dd>
            </dl>
          </ng-container>
          <c11n-hint-error
            [size]="'large'"
            [hasError]="!!errorMessage"
            [errorText]="errorMessage"
          >
          </c11n-hint-error>
        </section>

        <!-- Action Buttons -->
        <div class="button-group" [class.single-recipient]="recipients.length === 1" [class.content-responsive]="recipients.length <= 3">
          <c11n-button
            buttonType="button"
            [size]="'medium'"
            variant="secondary"
            [labelText]="content?.buttons?.back || 'Back'"
            (clickEvent)="onCancel()"
            [fullWidth]="isSmallScreen"
            colorMode="on-light">
          </c11n-button>
          <c11n-button
            buttonType="submit"
            [size]="'medium'"
            variant="primary"
            [labelText]="content?.buttons?.continue || 'Continue'"
            (clickEvent)="onContinue()"
            [fullWidth]="isSmallScreen"
            colorMode="on-light">
          </c11n-button>
        </div>
      </div>
    </div>
  </div>
</div>
